import React from 'react';
import { Link } from 'react-router-dom';
import './PageBreadcrumb.css';

export interface BreadcrumbItem {
  label: string;
  to?: string;
}

interface Props {
  items: BreadcrumbItem[];
}

const PageBreadcrumb: React.FC<Props> = ({ items }) => (
  <div className="page-breadcrumb-bar">
    <div className="container">
      <nav className="page-breadcrumb">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && <span className="page-breadcrumb-separator"> &gt; </span>}
            {item.to
              ? <Link to={item.to} className="page-breadcrumb-link">{item.label}</Link>
              : <span className="page-breadcrumb-current">{item.label}</span>
            }
          </React.Fragment>
        ))}
      </nav>
    </div>
  </div>
);

export default PageBreadcrumb;
